import { lazy, useMemo } from "react";
import { asyncWrapBrick } from "./asyncWrapBrick.js";

/**
 * 使用 `React.lazy` 包装一个异步加载的构件。
 *
 * ```jsx
 * const DepComponent = useLazyWrapBrick("async-dep");
 * return (
 *   <Suspense fallback="Loading...">
 *    <DepComponent {...props} />
 *   </Suspense>
 * );
 * ```
 */

/**
 * 使用 `React.lazy` 包装一个异步加载的构件。
 *
 * ```jsx
 * const DepComponent = useLazyWrapBrick("async-dep");
 * return (
 *   <Suspense fallback="Loading...">
 *    <DepComponent {...props} />
 *   </Suspense>
 * );
 * ```
 */

/**
 * 使用 `React.lazy` 包装一个异步加载的构件。
 *
 * ```jsx
 * const DepComponent = useLazyWrapBrick("async-dep");
 * return (
 *   <Suspense fallback="Loading...">
 *    <DepComponent {...props} />
 *   </Suspense>
 * );
 * ```
 */

/**
 * 使用 `React.lazy` 包装一个异步加载的构件。
 *
 * ```jsx
 * const DepComponent = useLazyWrapBrick("async-dep");
 * return (
 *   <Suspense fallback="Loading...">
 *    <DepComponent {...props} />
 *   </Suspense>
 * );
 * ```
 */

export function useLazyWrapBrick(brickName, eventsMapping) {
  return useMemo(() => {
    if (brickName != null) {
      return /*#__PURE__*/lazy(async () => ({
        default: await asyncWrapBrick(brickName, eventsMapping)
      }));
    }
    return null;
  }, [brickName, eventsMapping]);
}
//# sourceMappingURL=useLazyWrapBrick.js.map